import { type PricelistProductUpdateInput, usePricelistProductUpdateMutation } from "@/generated/graphql";

export const usePricelistProductUpdate = () => {
  const [, update] = usePricelistProductUpdateMutation();

  const updatePricelistProduct = (input: PricelistProductUpdateInput) => {
    return update({ input });
  };

  return {
    updatePricelistProduct,
  };
};
